module.exports = __webpack_public_path__ + "img/[偷笑].ed2c26ee.svg";